import {
  AcceptPrequalificationOfferResponse,
  GetPrequalificationOfferStatusResponse,
} from '@weave/schema-gen-ts/dist/schemas/payments-platform/care-credit-integration/care_credit_integration.pb';
import { EnrollmentFormResponseStatus } from '../enrollment-multi-step.types';

export const getPrequalificationOfferStatusResponseStatus = (
  response: GetPrequalificationOfferStatusResponse
): EnrollmentFormResponseStatus => {
  /**
   * From CC docs:
   * - Approved: "APPROVED", "CONDITIONALLY APPROVED"
   * - Pending: "APPLICATION QUEUED"
   * - Declined: "DECLINED PREVIOUSLY PROCESSED", "DECLINED", "DECLINED NO HIT", "FRAUD INTERNET", "NON FRAUD REFERRAL", "DECLINED CREDIT REPORT FREEZE"
   *
   * Known Decision Codes:
   *
   * | Code | Description        | Status  |
   * | ---- | ------------------ | ------- |
   * | 0012 | NON FRAUD REFERRAL | Pending |
   */

  const message = response.decisionMessage?.toLocaleLowerCase() || '';

  if (message.includes('approved')) {
    return 'success';
  }

  if (message.includes('declined') || message.includes('fraud')) {
    return 'declined';
  }

  if (response.decisionCode === '0012' || message.includes('queued')) {
    return 'pending';
  }

  console.error('Unknown decision message received from CareCredit:', response.decisionMessage);

  return 'pending'; // default to pending if unknown message
};

export const getPrequalificationOfferStatusResponseErrorDetails = (
  response: GetPrequalificationOfferStatusResponse
) => {
  if (!response.errorResponse) {
    return {
      message: undefined,
    };
  }

  const { errorCode, errorMessage, remediationInfo, errors } = response.errorResponse;

  return {
    errorCode,
    errorMessage,
    remediationInfo,
    errors,
    message: remediationInfo || errorMessage || 'An error occurred with your application. Please try again.',
  };
};

export const isDeclinedPrequalificationOfferAcceptanceResponse = (
  response: AcceptPrequalificationOfferResponse
): boolean => {
  if (!response.errorResponse) {
    return false;
  }

  // the "duplicate submission case should be counted as a win"
  if (response.errorResponse.errorCode === 'credit.application.badRequest') {
    const applicationIdError = response.errorResponse.errors?.find((error) => error.field === 'applicationId');
    if (applicationIdError?.reason === 'OfferAcceptance is not allowed for unapproved application') {
      return false;
    }
  }

  const { errorCode } = response.errorResponse;

  return !!errorCode;
};
export const getPrequalificationOfferAcceptanceResponseErrorDetails = (
  response: AcceptPrequalificationOfferResponse
) => {
  if (!response.errorResponse) {
    return {
      pieces: {},
      message: undefined,
    };
  }

  /*
  {
  "locationUrl": "",
  "applicationReferenceId": "",
  "errorResponse": {
      "errorCode": "credit.application.badRequest",
      "errorMessage": "Bad Request",
      "trackingId": "6b8e5cad-40dd-45cb-9f4f-26bcc23cc6ae",
      "remediationInfo": "Your request is having invalid data or missing parameters. Please verify and resubmit.",
      "transient": false,
      "accountInfo": null,
      "errors": [
          {
              "field": "applicationId",
              "location": "pathvariable",
              "reason": "OfferAcceptance is not allowed for unapproved application"
          }
      ],
      "activationRequired": false
  }
  */
  const { errorCode, errorMessage, remediationInfo, errors } = response.errorResponse;

  const applicationIdError = errors?.find((error) => error.field === 'applicationId');

  return {
    pieces: {
      errorCode,
      errorMessage,
      remediationInfo,
      applicationIdError,
    },
    message: applicationIdError?.reason
      ? `Application ID: ${applicationIdError.reason}. `
      : '' + remediationInfo || errorMessage || 'An error occurred with your application. Please try again.',
  };
};
